<template>
  <div class="column">
    <div class="container container_com-fundo container_com-margem">
      <loading :ativo="loading.visivel" :mensagem="loading.mensagem" />
      <alerta :tipo="tipoDeAlerta" :texto="mensagemDeAlerta" />
      <form @submit.prevent="salvarEmpreendimento" class="formulario">
        <h2 class="titulo titulo_grande">
          Preencha todos os campos obrigatórios abaixo para editar o
          empreendimento.
        </h2>
        <h3 class="subtitle is-5">
          <i class="fal fa-user-hard-hat"></i> Dados da construtora
        </h3>
        <div class="">
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_5">
              <label id="nome">Informe o nome da Construtora</label>
              <input
                name="nomeDaConstrutora"
                type="text"
                id="nomeDoEmpreendimento"
                class="input uppercase"
                alt="Informe o nome da Construtora"
                placeholder="Ex: RG ENGENHARIA LTDA"
                v-model="empreendimento.NomeDaConstrutora"
                required
              />
              <span class="example-input">Ex: RG ENGENHARIA LTDA</span>
            </div>

            <div class="grade__coluna grade__coluna_2">
              <label>CNPJ</label>
              <input
                name="numeroCNPJdaConstrutora"
                type="text"
                id="nomeDoEmpreendimento"
                class="input"
                placeholder="Ex: 00.192.450/0001-23"
                v-model="empreendimento.CnpjDaConstrutora"
                v-mask="'99.999.999/9999-99'"
                required
              />
              <span class="example-input">Ex: 00.192.450/0001-23</span>
            </div>
            <div class="grade__coluna grade__coluna_">
              <label>Dados bancários</label>
              <input
                name="dadosBancariosConstutora"
                type="text"
                id="nomeDoEmpreendimento"
                class="input uppercase"
                placeholder="Ex: AGENCIA 2054 OP 003 C/C 2708-6"
                v-model="empreendimento.ContaDaConstrutora"
                required
              />
              <span class="example-input"
                >Ex: AGENCIA 2054 OP 003 C/C 2708-6</span
              >
            </div>
          </div>
        </div>

        <h3 class="subtitle is-5">
          <i class="fal fa-building"></i> Novo empreendimento
        </h3>
        <div class="grade__linha">
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Projeto</label>
            <select
              v-model="empreendimento.ProjetoDeSubsidioId"
              required
              @change="obterCotas"
            >
              <option
                v-for="projeto in projetos"
                :value="projeto.Id"
                :selected="
                  projeto.Id === empreendimento.ProjetoDeSubsidioId
                    ? 'selected'
                    : ''
                "
              >
                {{ projeto.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Cidade</label>
            <select
              v-model="empreendimento.CidadeId"
              required
              @change="obterCotas"
            >
              <option
                v-for="cidade in cidades"
                :value="cidade.Id"
                :selected="
                  cidade.Id === empreendimento.CidadeId ? 'selected' : ''
                "
              >
                {{ cidade.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label">Tipo de imóvel</label>
            <select v-model="empreendimento.TipoDeEmpreendimento" required>
              <option
                v-for="tipoDeEmpreendimento in tiposDeEmpreendimento"
                :value="tipoDeEmpreendimento.Id"
                :selected="
                  empreendimento.TipoDeEmpreendimento ===
                  tipoDeEmpreendimento.Id
                    ? 'selected'
                    : ''
                "
              >
                {{ tipoDeEmpreendimento.Nome }}
              </option>
            </select>
          </div>
          <div class="grade__coluna grade__coluna_4">
            <label class="label" for="nomeDoEmpreendimento">Nome</label>
            <input
              name="nomeDoEmpreendimento"
              type="text"
              id="nomeDoEmpreendimento"
              class="input uppercase"
              placeholder="Ex: CONDOMÍNIO RESIDENCIAL ITACIRA"
              v-model="empreendimento.Nome"
              required
            />
            <span class="example-input"
              >Ex: CONDOMÍNIO RESIDENCIAL ITACIRA</span
            >
          </div>
          <div class="grade__coluna grade__coluna_2">
            <label class="label" for="quantidadeDeImoveisDisponiveis"
              >Total de imóveis do empreendimento</label
            >
            <input
              name="quantidadeDeImoveisDisponiveis"
              type="number"
              id="quantidadeDeImoveisDisponiveis"
              class="input uppercase"
              placeholder="Ex: 100"
              v-model="empreendimento.QuantidadeDeImoveisDisponiveis"
              required
            />
            <span class="example-input">Ex: 100</span>
          </div>
          <div
            v-if="empreendimento.ProjetoEhBonusMoradia"
            class="grade__coluna grade__coluna_2"
          >
            <label class="label" for="totalDeCotas">Cotas disponíveis</label>
            <input
              name="totalDeCotas"
              type="number"
              id="totalDeCotas"
              class="input uppercase"
              placeholder="Ex: 100"
              v-model="empreendimento.CotasDeDisponiveis"
              required
            />
            <span class="example-input">Ex: 100</span>
          </div>
          <div
            class="grade__coluna grade__coluna_4"
            style="display: flex; align-items: center"
          >
            <label class="formulario__label">
              <input
                type="checkbox"
                v-model="empreendimento.EhTerrenoPublicoDoado"
              />
              Terreno público doado
            </label>
          </div>
        </div>
        <div class="grade__linha">
          <div
            v-if="empreendimento.ProjetoEhBonusMoradia"
            class="grade__coluna grade__coluna_2"
          >
            <p class="texto-informativo">
              Total de cotas disponibilizadas:
              <strong>{{ empreendimento.CotaDeImoveis }}</strong>
            </p>
          </div>
          <div
            v-if="empreendimento.ProjetoEhBonusMoradia"
            class="grade__coluna grade__coluna_2"
          >
            <p class="texto-informativo">
              Cotas utilizadas:
              <strong>{{ empreendimento.CotasDeImoveisUsadas }}</strong>
            </p>
          </div>
          <div
            v-if="empreendimento.ProjetoEhBonusMoradia"
            class="grade__coluna grade__coluna_4"
          >
            <p class="texto-informativo">
              Total de cotas disponíveis no município:
              <strong>{{ empreendimento.CotasDisponiveisNoMunicipio }}</strong>
            </p>
          </div>
        </div>

        <h3 class="subtitle is-5">
          <i class="fal fa-building-columns"></i> Dados de correspondentes
          bancários
        </h3>
        <div class="formulario">
          <div class="grade__linha">
            <div class="grade__coluna grade__coluna_2">
              <input
                id="cpf"
                type="text"
                placeholder="Insira somente números do CPF"
                v-model="cpfDoCorrespondente"
                v-mask="'999.999.999-99'"
              />
            </div>
            <div class="grade__coluna grade__coluna_4">
              <button
                v-if="true"
                type="button"
                @click="adicionarCorrespondente"
                class="no-print botao botao_cor-terciaria botao_com-icone-para-direita botao_sem-preenchimento botao_medio"
              >
                <i class="fa fa-plus" aria-hidden="true"></i>
                Adicionar
              </button>
            </div>
          </div>
          <div class="grade__linha">
            <div
              class="grade__coluna grade__coluna_2"
              v-for="(correspondente, index) in empreendimento.Usuarios"
              :key="index"
            >
              <section class="card-correspondente">
                <header class="card-header">
                  <i class="fa-light fa-user"></i>
                  <button
                    type="button"
                    class="delete-btn"
                    @click="removerCorrespondente(index)"
                    title="Excluir"
                  >
                    <i class="fa-light fa-trash"></i>
                  </button>
                </header>
                <div class="card-body">
                  <h2 class="card-title">{{ correspondente.Nome }}</h2>
                  <p class="card-subtitle">{{ correspondente.Cpf }}</p>
                </div>
              </section>
            </div>
          </div>
        </div>

        <hr />
        <div class="grade__linha">
          <router-link
            :to="{
              name: 'VisualizarEmpreendimento',
              query: { idDoEmpreendimento: empreendimentoId },
            }"
            class="botao botao_medio botao_cinza u-margem-direita-pequena"
            :class="{ 'is-disabled': loading.visivel }"
            >Cancelar</router-link
          >
          <button
            type="submit"
            class="botao botao_medio botao_cor-terciaria"
            :class="{ 'is-loading': loading.visivel }"
          >
            Salvar empreendimento
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import AwesomeMask from "awesome-mask";
import Loading from "../shared/Loading";
import Alerta from "../shared/Alerta";

export default {
  name: "cadastrar-empreendimento",
  components: { Loading, Alerta },
  data() {
    return {
      empreendimentoId: null,
      empreendimento: {
        CidadeId: null,
        TipoDeEmpreendimento: null,
        ProjetoDeSubsidioId: null,
        CotasDisponiveisNoMunicipio: null,
        EhTerrenoPublicoDoado: false,
        Usuarios: [],
      },
      cidades: this.cidades || [],
      construtoras: this.construtoras || [],
      projetos: this.projetos || [],
      cpfDoCorrespondente: null,
      tiposDeEmpreendimento: [
        {
          Id: null,
          Nome: "Selecione um tipo de imóvel",
        },
        {
          Id: 1,
          Nome: "Apartamento",
        },
        {
          Id: 2,
          Nome: "Casa",
        },
        {
          Id: 3,
          Nome: "Casa e apartamento",
        },
      ],
      loading: {
        visivel: false,
      },
      mensagemDeAlerta: null,
      tipoDeAlerta: null,
    };
  },
  created() {
    this.empreendimentoId = this.$route.query.idDoEmpreendimento;
    this.obterCidades();
    this.obterConstrutoras();
    this.obterProjetos();
    this.obterEmpreendimento(this.empreendimentoId);
  },
  directives: { mask: AwesomeMask },
  methods: {
    projetoEhBonusMoradia() {
      if (!this.empreendimento.ProjetoDeSubsidioId) return false;
      const projeto = this.projetos.filter(
        (p) => p.Id == this.empreendimento.ProjetoDeSubsidioId
      )[0];
      return projeto.EhBonusMoradia;
    },
    obterCotas() {
      this.empreendimento.CotasDisponiveisNoMunicipio = null;
      if (
        !this.empreendimento.CidadeId ||
        !this.empreendimento.ProjetoDeSubsidioId
      )
        return;

      this.$api
        .get(
          `/Cidade/ObterCotasDisponiveis/${this.empreendimento.CidadeId}/${this.empreendimento.ProjetoDeSubsidioId}`
        )
        .then((response) => {
          this.empreendimento.CotasDisponiveisNoMunicipio = response.data;
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    salvarEmpreendimento() {
      this.exibirCarregamento(
        "Só um momento, estamos salvando as alterações do empreendimento..."
      );
      const empreendimento = JSON.parse(
        JSON.stringify(this.$data.empreendimento)
      );
      empreendimento.Nome = empreendimento.Nome.toUpperCase();
      empreendimento.NomeDaConstrutora =
        empreendimento.NomeDaConstrutora.toUpperCase();
      empreendimento.ContaDaConstrutora =
        empreendimento.ContaDaConstrutora.toUpperCase();
      empreendimento.CotaDeImoveis =
        +empreendimento.CotasDeDisponiveis +
        +empreendimento.CotasDeImoveisUsadas;

      this.$api
        .put(`/Empreendimento/${this.empreendimentoId}`, empreendimento)
        .then(() => {
          this.$router.push({ name: "ListaDeEmpreendimentos" });
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    obterConstrutoras() {
      this.$api
        .get("/Construtora")
        .then((response) => {
          this.construtoras = [{ Id: null, Nome: "Selecione uma construtora" }];
          this.construtoras = this.construtoras.concat(response.data);
          return response;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    obterCidades() {
      this.$api
        .get("/Cidade")
        .then((response) => {
          this.cidades = [{ Id: null, Nome: "Selecione uma cidade" }];
          this.cidades = this.cidades.concat(response.data);
          return response;
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    obterProjetos() {
      this.$api
        .get("/Projeto")
        .then((response) => {
          this.projetos = [{ Id: null, Nome: "Selecione um projeto" }];
          this.projetos = this.projetos.concat(response.data);
          return response;
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    obterEmpreendimento(empreendimentoId) {
      this.$api
        .get(`/Empreendimento/${empreendimentoId}`)
        .then((response) => {
          this.empreendimento.Id = response.data.Id;
          this.empreendimento.CidadeId = response.data.Cidade.Id;
          this.empreendimento.TipoDeEmpreendimento =
            response.data.TipoDeEmpreendimentoId;
          this.empreendimento.Nome = response.data.Nome;
          this.empreendimento.NomeDaConstrutora =
            response.data.Construtora.Nome;
          this.empreendimento.CnpjDaConstrutora =
            response.data.Construtora.Cnpj;
          this.empreendimento.ContaDaConstrutora =
            response.data.Construtora.Conta;
          this.empreendimento.ProjetoDeSubsidioId =
            response.data.ProjetoDeSubsidioId;
          this.empreendimento.ProjetoEhBonusMoradia =
            response.data.ProjetoEhBonusMoradia;
          this.empreendimento.CotaDeImoveis = response.data.CotaDeImoveis;
          this.empreendimento.CotasDeImoveisUsadas =
            response.data.CotasDeImoveisUsadas;
          this.empreendimento.CotasDeDisponiveis =
            response.data.CotaDeImoveis - response.data.CotasDeImoveisUsadas;
          this.empreendimento.CotasDisponiveisNoMunicipio =
            response.data.CotasDisponiveisNoMunicipio;
          this.empreendimento.QuantidadeDeImoveisDisponiveis =
            response.data.QuantidadeDeImoveisDisponiveis;
          this.empreendimento.EhTerrenoPublicoDoado =
            response.data.EhTerrenoPublicoDoado;
          this.empreendimento.Usuarios = response.data.UsuariosComPermissao;
          return response;
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    exibirCarregamento(mensagem) {
      this.loading.visivel = true;
      this.loading.mensagem = mensagem;
    },
    esconderCarregamento() {
      this.loading.visivel = false;
      this.loading.mensagem = null;
    },
    tratarErro(error) {
      this.esconderCarregamento();
      this.tipoDeAlerta = "erro";
      const mensagensDeErro = error.response.data.Message;
      this.mensagemDeAlerta =
        mensagensDeErro ||
        "Desculpe, ocorreu um erro interno. Tente novamente ou contate o suporte";
    },
    adicionarCorrespondente() {
      this.exibirCarregamento("");
      const cpfDoCorrespondente = this.removerMascaraCpf(
        this.cpfDoCorrespondente
      );
      const correspondenteJaFoiAdicionado = this.empreendimento.Usuarios.some(
        (p) => p.Cpf === cpfDoCorrespondente
      );
      if (correspondenteJaFoiAdicionado) {
        this.exibirAlerta("CPF já adicionado", "atencao");
        this.cpfDoCorrespondente = null;
        this.esconderCarregamento();
        return;
      }

      this.$api
        .get(`/Usuario/${cpfDoCorrespondente}`)
        .then((resultado) => {
          this.esconderCarregamento();
          if (resultado.data === null) {
            let mensagem = "Cpf não encontrado";
            this.exibirAlerta(mensagem, "atencao");
          } else {
            const usuario = resultado.data;
            var correspondente = {
              Cpf: usuario.Cpf,
              Login: usuario.Login,
              Nome: usuario.Nome,
            };
            this.empreendimento.Usuarios.push(correspondente);
            this.cpfDoCorrespondente = null;
          }
        })
        .catch((error) => {
          this.tratarErro(error);
        });
    },
    removerCorrespondente(index) {
      this.empreendimento.Usuarios.splice(index, 1);
    },
    removerMascaraCpf(cpf) {
      return cpf.replace(/\D/g, "");
    },
    exibirAlerta(mensagem) {
      this.tipoDeAlerta = "erro";
      this.mensagemDeAlerta =
        mensagem ||
        "Ocorreu um erro interno. Tente novamente ou contate o suporte";
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>



// WEBPACK FOOTER //
// EditarEmpreendimento.vue?22f90ffa